import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";

export const getAllInquiries = createAsyncThunk(
  "TourServices/FindAllWebsiteInquiry",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TourServices/FindAllWebsiteInquiry`,
        payload
      );
      return response.data.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching users:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
